import { ColorScheme } from '@/types'
import { Badge, type BadgeProps } from '@chakra-ui/react'
import React from 'react'


interface Props extends BadgeProps {
  colorScheme?: ColorScheme,
}

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <Badge ref={ref} { ...props } />
  )
})

export {
  Component as Badge,
  type Props as BadgeProps,
}
